module.exports = __webpack_public_path__ + "static/media/touch.7c449909.png";